import React from 'react';
import './bookItemPlaceholder.css';

const BookItemPlaceholder = () => (
  <div className="manuscript-book-skeleton" aria-hidden="true">
    <span className="manuscript-book-skeleton__cover" />
    <div className="manuscript-book-skeleton__content">
      <div className="manuscript-book-skeleton__heading">
        <span className="manuscript-book-skeleton__privacy" />
        <span className="manuscript-book-skeleton__line manuscript-book-skeleton__title" />
      </div>
      <span className="manuscript-book-skeleton__line manuscript-book-skeleton__byline" />
      <span className="manuscript-book-skeleton__line manuscript-book-skeleton__summary" />
      <span className="manuscript-book-skeleton__line manuscript-book-skeleton__summary-short" />
      <div className="manuscript-book-skeleton__metrics">
        <span className="manuscript-book-skeleton__metric" />
        <span className="manuscript-book-skeleton__metric" />
        <span className="manuscript-book-skeleton__metric" />
      </div>
    </div>
  </div>
);

export default BookItemPlaceholder;
